module.exports = __webpack_public_path__ + "static/media/sample.023da4f1.svg";